export default __webpack_public_path__ + "static/media/ticket-watermark.58980a80.png";